export default __webpack_public_path__ + "static/media/p2.c74ca88e.jpg";